import { render, staticRenderFns } from "./RecentUpdates.vue?vue&type=template&id=d2cb1b1e&scoped=true"
import script from "./RecentUpdates.vue?vue&type=script&lang=js"
export * from "./RecentUpdates.vue?vue&type=script&lang=js"
import style0 from "./RecentUpdates.vue?vue&type=style&index=0&id=d2cb1b1e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2cb1b1e",
  null
  
)

export default component.exports